export default "__VITE_ASSET__Dj1usOv9__"